import { ApiClient } from '@/apiClient'
import * as Sentry from "@sentry/browser";

export class UserService {
  apiClient: ApiClient = new ApiClient()

  async forgotPassword(email: string) {
    return await this.apiClient
      .forgotPassword(email)
      .then((response: any) => {
        return true;
      })
      .catch((err: any) => {
        Sentry.captureException(err);
        return false;
      })
  }

  async resetPassword(oldPass: string, password: string) {
    return await this.apiClient
      .resetPassword(oldPass, password)
  }
}
